import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const conversations = (rawClient) => ({
    list: allpeepNoPayloadEndpoint(rawClient, '/conversations'),
    findById: allpeepNoPayloadEndpoint(rawClient, '/conversations/:id'),
    newPost: allpeepPayloadEndpoint(rawClient, '/conversations/:id/posts'),
});
